import './App.css';
import HomePage from './pages/homePage';
import DiscountedPage from './pages/discountedPage'
import EarringsPage from './pages/earrings'
import EngagementPage from './pages/engagement'
import ProductInfo from './pages/productProfile'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EternityPage from './pages/eternity';
import NecklacePage from './pages/necklace';
import BraceletPage from './pages/bracelet';
import BanglesPage from './pages/bangles';
import AboutUs from './pages/aboutUs';
import ScrollToTop from './common/scrollToTop';
import LoosePage from './pages/loose';
import GiaPage from './pages/giaAndNon';
import NaturalPage from './pages/natural';




function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Routes>
        {/* Initial page set to Home */}
        <Route path="/homePage" element={<HomePage />} />

        {/* Additional route for "/" to also load Home */}
        <Route path="/" element={<HomePage />} />
        <Route path="/discount-page" element={<DiscountedPage/>} />
        <Route path="/earrings-page" element={<EarringsPage/>} />
        <Route path="/engagement-page" element={<EngagementPage/>} />
        <Route path="/eternity-page" element={<EternityPage/>} />
        <Route path="/necklace-page" element={<NecklacePage/>} />
        <Route path="/bracelet-page" element={<BraceletPage/>} />
        <Route path="/about-us" element={<AboutUs/>} />
        <Route path="/bangles-page" element={<BanglesPage/>} />
        <Route path="/loose-page" element={<LoosePage/>} />
        <Route path="/gia-page" element={<GiaPage />} />
        <Route path="/natural-page" element={<NaturalPage />} />
        <Route path="/product/:id" element={<ProductInfo />} />


      </Routes>
    </Router>
  );
}

export default App;

